import React from "react"
import { Route, Redirect } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { LoaderSuspense } from "../utils/loader"

export default function PrivateRoute({ component: Component, ...rest }) {
  const { claims, logged, status, user } = useAuth()

  // console.log(claims)
  const LoggedAndHasRole = (props) => {
    if (status === "loading") {
      return <LoaderSuspense />
    } else {
      if (!logged) {
        return <Redirect to="/auth/login" />
      } else if (claims.length === 0) {
        return <LoaderSuspense />
      } else if (user.status !== "a") {
        return <Redirect to="/status" />
      } else if (claims?.role === 'admin' || claims?.role === 'agent') {
        return <Component {...props} />
      } else {
        return <Redirect to="/403" />
      }
    }
  }

  return (
    <Route
      {...rest}
      render={props => {
        return <LoggedAndHasRole {...props} />
      }}
    />
  )
}
